/**
 * PanelErrorState — the panel tab's FAILED-fetch state.
 * SPEC-stakeholder-portal-presentation-redesign-2026-07-20, R3 AC7.
 *
 * Deliberately distinct from a tab's legitimate empty state (e.g. "No reports
 * yet"): a real network/500/timeout failure renders THIS — a clear message +
 * a retry affordance — never the warm "you have nothing here" copy, which
 * would misrepresent a failure as a legitimate empty result.
 */
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PanelErrorStateProps {
  /** What failed to load, e.g. "your submissions", "the roadmap". */
  what: string;
  onRetry: () => void;
  testId?: string;
}

export function PanelErrorState({ what, onRetry, testId }: PanelErrorStateProps) {
  return (
    <div
      className="flex flex-col items-center gap-2 py-8 text-center text-sm"
      data-testid={testId ?? 'panel-error-state'}
    >
      <AlertTriangle className="h-5 w-5 text-destructive" aria-hidden />
      <p className="text-destructive">Could not load {what}.</p>
      <Button size="sm" variant="outline" onClick={onRetry} data-testid="panel-error-retry">
        Try again
      </Button>
    </div>
  );
}
